import UserStatus from "@/domain/enums/UserStatus";

type StatusDetailProps = {
    status: UserStatus;
    holdDate: Date | null;
    deactivatedDate: Date | null;
    archivedDate: Date | null;
};

export default class StatusDetail {
    status: UserStatus;

    holdDate: Date | null;

    deactivatedDate: Date | null;

    archivedDate: Date | null;

    constructor({
        status,
        holdDate,
        deactivatedDate,
        archivedDate,
    }: StatusDetailProps) {
        this.status = status;
        this.holdDate = holdDate;
        this.deactivatedDate = deactivatedDate;
        this.archivedDate = archivedDate;
    }
}
